var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatetime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 888.48 79.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fbc445;stroke-miterlimit:10;stroke-width:1.5px;}.cls-2{fill:#fbc445;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.68,49V60.09H1.09V53.38l21-25.2C24,26.08,25,24,25,22.37c0-2.91-2.5-5-6.14-5-4.2,0-6.46,3.07-7.11,7.59L.85,23.26C2.3,13.32,8.36,6.37,19.51,6.37c10.82,0,17.69,6.47,17.69,16.16,0,5.41-2.34,9.61-5.66,13.33L19.83,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.34,22.85c0,9.29-5.82,18.34-18.74,18.34H60v18.9H47.27V4.44H110.6C123.52,4.44,129.34,13.64,129.34,22.85Zm-12.77,0c0-3.55-1.77-7.35-6.46-7.35H60V30.12H110C114.8,30.12,116.57,26.41,116.57,22.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.14,60.09l-3.63-31.67L171.39,53.71H161.7l-12.12-25.2-3.71,31.58h-13l6.87-55.65h10.58l16.23,34.81,16-34.81h10.82l6.79,55.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265,49V60.09H228.56V4.44h35.7V15.5h-23V27h20.19V38.36H241.24V49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.22,43.61H284.9c0,3.56,3.55,6.3,7.92,6.3,4.11,0,7.27-1.86,7.27-5.49,0-2.18-1.22-4.2-6.14-5.82l-6.63-2c-12.27-3.31-14.62-10.82-14.62-16.07,0-10,8.57-16.8,19.63-16.8,10.66,0,18.82,6.38,18.82,17.2H298.47c0-3.31-2-6.13-6.38-6.13-4,0-6.54,2.42-6.54,5.49,0,1.13.32,3.63,5.49,5.09l5.81,1.77c7.92,2.43,16,6.55,16,16.64,0,12-10.34,17-20.52,17C280.46,60.82,272.22,53.87,272.22,43.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.93,15.5h-14.7V60.09H331.55V15.5h-14.7V4.44h42.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501,77.78l1.13-11.47c2.51.89,7,.89,7.44.89,4.11,0,5.73-3.15,5.73-7V4.44H528V60.17c0,10.26-4.93,19-18.41,19A35,35,0,0,1,501,77.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539.94,40V4.44h12.68V39c0,7,4.45,9.77,9,9.77s9-2.75,9-9.77V4.44h12.68V40c0,12.84-10.18,20.84-21.65,20.84S539.94,52.82,539.94,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M595.36,4.44H608V49h60.83V60.09H595.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M717.5,4.44,695.78,35.21V60.09H683V35L661.37,4.44h15.1L689.31,25,702.4,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M761.5,6.37V60.09H749.63V22.21L737,27V16l23.5-9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M804.57,44.74c0,9.53-8.32,16.08-20,16.08-7.59,0-13.49-2.83-17.44-8.57l7.91-6.7c2.59,2.83,5.25,4.52,9,4.52,5.09,0,8.32-2.66,8.32-6.46s-3.32-6.7-8.32-6.7h-4.85V28.1h2.1c5.9,0,9-3.07,8.72-6.46-.24-2.67-2.74-4.36-6.22-4.36a11.74,11.74,0,0,0-8.8,4l-6.14-7.68a22.51,22.51,0,0,1,16.56-7.27c9.37,0,17,5.66,16.8,14.79,0,4.28-2.67,8.07-7.11,10.33C800.86,33.68,804.57,38.52,804.57,44.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M831.55,7.2H823v26h-7.39V7.2H807V.75h24.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M887.73.75V33.19h-7.39V20.38H842.73V33.19h-7.4V.75h7.4v13h37.61V.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 371.93,
    y: 31.51,
    width: 122.04,
    height: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatetime);
export default __webpack_public_path__ + "static/media/datetime.d8dd07775ed55b5071c2d059e5f53ecc.svg";
export { ForwardRef as ReactComponent };